export default __webpack_public_path__ + "static/media/info.7f643d81.svg";